// extracted by mini-css-extract-plugin
module.exports = {"historyRecycleCompletes":"HistoryRecycleCompletes_historyRecycleCompletes__vbT3a","commonCard":"HistoryRecycleCompletes_commonCard__3ci4L"};